import { connect } from 'react-redux';
import { callSelectors } from '@lifesize/nucleus';
import AvSettingsModal from 'components/AvSettingsModal/AvSettingsModal';
import { closeInCallModal } from 'actions/InCallModal';
import { isCallConnected } from 'utils/call-utils';
import actions from 'actions/AvSettingsModal';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const rememberSettings = _get(state, 'app.avSettings.rememberSettings');
  const preserveSettings = _get(state, 'app.avSettings.preserveAvSettings');
  const defaultAudioSetting = preserveSettings ?
    _get(state, 'app.avSettings.audio') : _get(state, 'app.settingsModal.defaultAudioSetting');
  const activeCall = callSelectors.activeCallSelector(state);
  const isInCall = isCallConnected(activeCall);
  const isWebConferencing = _get(callSelectors.activeCallSelector(state), 'isWebConferencing');

  return {
    rememberSettings,
    defaultAudioSetting,
    preserveSettings,
    isInCall,
    isWebConferencing
  };
};

const mapDispatchToProps = dispatch => ({
  toggleRememberSettings: () => { dispatch(actions.toggleRememberSettings()); },
  setAudioMuteState: (defaultAudioSetting) => {
    dispatch(actions.toggleNextCallAudio(defaultAudioSetting));
  },
  closeInCallModal: () => dispatch(closeInCallModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(AvSettingsModal);
